import { Link } from "@tanstack/react-router";
import { ContentHeader } from "@cx/ui";
import { can, type Permissions } from "@cx/db";
import { useSession } from "../session";

export function HomePage() {
  const { me } = useSession();
  return (
    <>
      <ContentHeader title={`Olá, ${me.user.name.split(" ")[0]}`} />
      {can(me.permissions as Permissions, "dashboard", "read") ? (
        <p className="text-muted">
          Acompanhe as vendas no <Link to="/meu-negocio/dashboard">Dashboard do Meu Negócio</Link>.
        </p>
      ) : (
        <p className="text-muted">Comece pelo cadastro de clientes e fornecedores.</p>
      )}
    </>
  );
}
